import React from 'react';
import { Credibility } from '../../../models/CreditCheckResult';
import FontAwesomeIcon from '../../core/fa_icon';
import { Sparks } from '../../core/sparks';
import styles from './credibility_indicator.module.scss';

type Props = {
  credibility: Credibility;
  credibilityDescription: string;
}

export const CredibilityIndicator: React.FC<Props> = ({ credibility, credibilityDescription }) => {
  const isOk = credibility === "1";

  return (
    <div className={styles.credibility} data-credibility={String(credibility)}>
      <FontAwesomeIcon
        className={styles.icon}
        name="lightbulb"
        type={isOk ? 'solid' : 'regular'} />
      {
        isOk ? (
          <Sparks
            sparkClassName={styles.spark}
            length={24}
            _ref={e => setTimeout(() => e?.trigger(), 350)} />
        ) : null
      }

      <p className={styles.description}>{credibilityDescription}</p>
    </div>
  )
}